const hasComponentTypes = (
  formSchema: unknown,
  componentTypesToCheck: string[]
): boolean => {
  if (
    !formSchema ||
    typeof formSchema !== 'object' ||
    !('components' in formSchema)
  )
    return false

  const schema = formSchema as { components: unknown[] }
  if (!Array.isArray(schema.components)) return false

  const checkComponents = (components: unknown[]): boolean => {
    for (const component of components) {
      if (typeof component !== 'object' || component === null) continue

      const comp = component as Record<string, unknown>

      if (componentTypesToCheck.includes(comp.type as string)) {
        return true
      }
      if (Array.isArray(comp.components)) {
        if (checkComponents(comp.components)) {
          return true
        }
      }
      if (Array.isArray(comp.columns)) {
        for (const column of comp.columns) {
          if (typeof column === 'object' && column !== null) {
            const col = column as Record<string, unknown>
            if (
              Array.isArray(col.components) &&
              checkComponents(col.components)
            ) {
              return true
            }
          }
        }
      }
      if (Array.isArray(comp.rows)) {
        for (const row of comp.rows) {
          if (typeof row === 'object' && row !== null) {
            const r = row as Record<string, unknown>
            if (Array.isArray(r.components) && checkComponents(r.components)) {
              return true
            }
          }
        }
      }
    }
    return false
  }

  return checkComponents(schema.components)
}

export default hasComponentTypes
